import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { isDeliveryPartner, parseStoredUser } from "@/utils/userRoles";

const ProtectedRoute = ({ children }) => {
  const token = localStorage.getItem("token");
  const user = parseStoredUser();
  const userAction = localStorage.getItem("is_change_password_denied") ?? false;

  const location = useLocation();

  if (!token) {
    return <Navigate to="/sign-in" replace />;
  }
  
  if (!isDeliveryPartner(user)) {
    // Check if they are ALREADY on the page where they can change their password
    const isChangingPassword = location.pathname === "/dashboard/profile/edit" &&
      location.search.includes("tab=change_password");
  
    if (user?.must_reset_password && !isChangingPassword && !userAction) {
      return <Navigate
        to="/dashboard/profile/edit?tab=change_password"
        replace
      />;
    }
  }


  return children;
};

export default ProtectedRoute;